/* global axios */
import ApiClient from './ApiClient';

// Client do catálogo PRÓPRIO de etiquetas de fluxo — #1197. Irmão do client de
// diretórios, e pelo mesmo motivo: as duas são organização da CONTA, não de um
// fluxo, e a tela de fluxos carrega as duas no mount.
//
// Não é o client de `labels`: aquele é o catálogo de atendimento (conversa,
// contato, empresa), que vive na tabela `tags` com índice UNIQUE GLOBAL de
// nome. Ver `AutomationFlowLabel` no backend.
//
// `create`/`update`/`delete` vêm do ApiClient; o ParamsWrapper do Rails embrulha
// o corpo em `automation_flow_label` sozinho, porque `title`, `color` e
// `description` são colunas do modelo.
class AutomationFlowLabelsAPI extends ApiClient {
  constructor() {
    super('automation_flow_labels', { accountScoped: true });
  }

  // Sem paginação de propósito, igual ao de diretórios: o catálogo é curto por
  // natureza e a tela precisa dele inteiro para o filtro, o seletor do modal
  // "Organizar" e a caixa de gerenciar.
  get() {
    return axios.get(this.url);
  }
}

export default new AutomationFlowLabelsAPI();
